var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var CrossRoundedIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 50,
    glyphHeight: 50
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M38.8091 0.75807C29.7083 -0.25269 20.2917 -0.25269 11.1909 0.75807C5.80231 1.35583 1.44786 5.5945 0.81646 11.007C-0.272153 20.2994 -0.272153 29.6897 0.81646 38.993C1.44786 44.4055 5.80231 48.6442 11.1909 49.2419C20.2917 50.2527 29.7083 50.2527 38.8091 49.2419C44.1977 48.6333 48.5521 44.4055 49.1835 38.993C50.2722 29.6897 50.2722 20.2994 49.1835 11.007C48.5521 5.5945 44.1977 1.35583 38.8091 0.75807ZM11.6808 5.1489C20.455 4.17074 29.5341 4.17074 38.3192 5.1489C41.6939 5.51842 44.3936 8.18118 44.7855 11.5178C45.8306 20.4733 45.8306 29.5158 44.7855 38.4714C44.3936 41.7971 41.6939 44.4598 38.3192 44.8402C29.545 45.8184 20.4659 45.8184 11.6808 44.8402C8.30612 44.4707 5.60636 41.808 5.21446 38.4714C4.16939 29.5158 4.16939 20.4733 5.21446 11.5178C5.60636 8.18118 8.30612 5.51842 11.6808 5.1489ZM17.7117 14.6044C16.8517 13.7458 15.4474 13.7458 14.5874 14.6044C13.7274 15.463 13.7274 16.865 14.5874 17.7236L21.8702 24.9945L14.5874 32.2655C13.7274 33.1241 13.7274 34.5261 14.5874 35.3847C15.4474 36.2433 16.8517 36.2433 17.7117 35.3847L24.9945 28.1138L32.2774 35.3847C33.1374 36.2433 34.5417 36.2433 35.4017 35.3847C36.2617 34.5261 36.2617 33.1241 35.4017 32.2655L28.1188 24.9945L35.4017 17.7236C36.2617 16.865 36.2617 15.463 35.4017 14.6044C34.5417 13.7458 33.1374 13.7458 32.2774 14.6044L24.9945 21.8753L17.7117 14.6044Z",
    fill: "black"
  }));
};
export var CrossRoundedIconGlyph = function (props) {
  return React.createElement(CrossRoundedIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};